import { getByPath } from "@coworker/apprestructured/src/shared/helpers/object.helper";
import { ListItem } from "../components/SelectListItem/SelectListItem";

export type VisibilityOperator = "in" | "equals" | "notEquals" | "notIn";

export interface VisibilityCondition {
  field: string;
  value: any;
  operator: VisibilityOperator;
}

type OperatorStrategy = (currentValue: any, expectedValue: any) => boolean;

/**
 * Strategy map for visibility operators
 * New operators can be added here without modifying existing code
 */
const operatorStrategies: Record<VisibilityOperator, OperatorStrategy> = {
  in: (currentValue, expectedValue) =>
    Array.isArray(expectedValue) ? expectedValue.includes(currentValue) : false,

  equals: (currentValue, expectedValue) => currentValue === expectedValue,

  notEquals: (currentValue, expectedValue) => currentValue !== expectedValue,

  notIn: (currentValue, expectedValue) =>
    Array.isArray(expectedValue) ? !expectedValue.includes(currentValue) : true,
};

/**
 * Determines if a field should be displayed based on visibility conditions
 * @param task - The task object containing field values
 * @param visibility - The visibility condition to evaluate
 * @returns true if the field should be shown, false otherwise
 */
export function shouldShowField(
  task: Record<string, any>,
  visibility: VisibilityCondition
): boolean {
  const currentValue = getByPath(task, visibility.field) as ListItem | null;
  const strategy = operatorStrategies[visibility.operator];

  if (!strategy) {
    console.warn(
      `Unknown operator: ${visibility.operator}, defaulting to true`
    );
    return true;
  }

  return strategy(
    typeof currentValue === "object" ? currentValue?.value : currentValue,
    visibility.value
  );
}
